import { render, staticRenderFns } from "./CheckboxButtonQuestionOptions.vue?vue&type=template&id=6be222c2&scoped=true&"
import script from "./CheckboxButtonQuestionOptions.vue?vue&type=script&lang=js&"
export * from "./CheckboxButtonQuestionOptions.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxButtonQuestionOptions.vue?vue&type=style&index=0&id=6be222c2&prod&scoped=true&lang=css&"
import style1 from "./CheckboxButtonQuestionOptions.vue?vue&type=style&index=1&id=6be222c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be222c2",
  null
  
)

export default component.exports